var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sourcery__grid mt-12"},_vm._l((4),function(n){return _c('AppCardSkeleton',{key:n,staticClass:"pa-3 flex-grow-1 mx-0"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }